import { Component, OnInit, ViewChild, NgZone, Inject, PLATFORM_ID } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../../core/services/event.service';

import { ConfigService } from '../../../core/services/config.service';
import { ActivatedRoute, Router } from '@angular/router';

import { DatePipe, Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, Validators, AbstractControl } from '@angular/forms';
import { SubsctiptionService } from '../../../core/services/subscription.service';
import { JwtAuthService } from '../../../core/services/auth.service';
import { Observable } from 'rxjs';

import Swal from 'sweetalert2';

import { MapsAPILoader } from '@agm/core'; 
// import {  } from 'google.maps';
import { isPlatformBrowser } from '@angular/common';

import { WizardComponent } from 'angular-archwizard';


@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  longitude = 55.2708;
  latitude = 25.2048;
  markers: any;

  @ViewChild('streetviewMap', { static: false }) streetviewMap: any;
  @ViewChild('streetviewPano', { static: true }) streetviewPano: any;

  breadCrumbItems: Array<{}>;

  markerVisible: Boolean;

  validationform: UntypedFormGroup;
  validationfreelancer: UntypedFormGroup;
  validationcompany: UntypedFormGroup;


  submitPressed: boolean;
  submitPressedFreelancer: boolean;
  submitPressedCompany: boolean;
  validation: boolean;
  validation_freelancer: boolean;
  validation_company: boolean;
  
  isImageValid = true;
  isImageValidFreelancer = true;
  isEmirateIDValidFreelancer = true;
  isPassportValidFreelancer = true;
  isTenantContractValidFreelancer = true;
  isImageValidCompany = true;
  isEmirateIDValidCompany = true;
  isPassportValidCompany = true;
  isTenantContractValidCompany = true;
  isTradeLicenseValidCompany = true;
  

  // latitude: number;
  // longitude: number;

  tab: Number;

  serviceDetails: any;

  selectValue: string[];

  // bread crumb items
  // breadCrumbItems: Array<{}>;

  formData = {
    image: null,
    image_freelancer: null,
    emirates_id_freelancer: null,
    passport_freelancer: null,
    tenant_contract_freelancer: null,
    image_company: null,
    emirates_id_company: null,
    passport_company: null,
    tenant_contract_company: null,
    trade_license_company: null,
  };

  activeTab: number;
  // activeIdString: string;


  // @ViewChild(AgmMap) map: AgmMap;
  @ViewChild('wizard') wizard: WizardComponent;
 

  // set the currenr year
  year: number = new Date().getFullYear();

  // tslint:disable-next-line: max-line-length
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    public formBuilder: UntypedFormBuilder, 
    private route: ActivatedRoute, 
    private router: Router, 
    private authenticationService: JwtAuthService,
    private subscriptionService: SubsctiptionService,
    private mapsAPILoader: MapsAPILoader, 
    private ngZone: NgZone) {
      this.serviceDetails = {};
     }



  ngOnInit() {
    // this.breadCrumbItems = [{ label: 'Forms' }, { label: 'Form Validation', active: true }];

    // Collapse value
    // this.isCollapsed = false;

    
    this.route.queryParams.subscribe(params => {
      const tabFromRoute = +params.tab; // Convert to number using "+"
      if (!isNaN(tabFromRoute)) {
        this.changeActiveTab(tabFromRoute);
      }

      // this.activeTab = params.tab || 1;
      // this.tab = this.activeTab;
      // this.customNav.select(this.activeTab);
    });

   

    this.validationform = this.formBuilder.group({
      name: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9]+([ ][a-zA-Z0-9]+)*$')]],
      email: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9-]+.[a-z]{2,3}$')]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      gender: ['', [Validators.required]],
      phone_number: ['', [Validators.required, Validators.pattern('[0-9]{9}$')]],
      address_name: ['', [Validators.required]],
      area: ['', [Validators.required]],
      building: ['', [Validators.required]],
      apartment: ['', [Validators.required]],
      country: ['', [Validators.required]],
      city: ['', [Validators.required]],
      latitude: ['', [Validators.required, Validators.pattern('^-?[0-9]{1,3}\.[0-9]{5,15}$')]],
      longitude: ['', [Validators.required, Validators.pattern('^-?[0-9]{1,3}\.[0-9]{5,15}$')]],
      image: [''],
    });

    this.validationfreelancer = this.formBuilder.group({
      // services: ['', [Validators.required], this.maxSelectedValues(4)],
      services: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9]+([ ][a-zA-Z0-9]+)*$')]],
      email: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9-]+.[a-z]{2,3}$')]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      gender: ['', [Validators.required]],
      phone_number: ['', [Validators.required, Validators.pattern('[0-9]{9}$')]],
      address_name: ['', [Validators.required]],
      area: ['', [Validators.required]],
      building: ['', [Validators.required]],
      apartment: ['', [Validators.required]],
      country: ['', [Validators.required]],
      city: ['', [Validators.required]],
      latitude: ['', [Validators.required, Validators.pattern('^-?[0-9]{1,3}\.[0-9]{5,15}$')]],
      longitude: ['', [Validators.required, Validators.pattern('^-?[0-9]{1,3}\.[0-9]{5,15}$')]],
      image: [''],
      emirates_id: ['', [Validators.required]],
      passport: [''],
    });

    this.validationcompany = this.formBuilder.group({
      services: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9]+([ ][a-zA-Z0-9]+)*$')]],
      email: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9-]+.[a-z]{2,3}$')]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      phone_number: ['', [Validators.required, Validators.pattern('[0-9]{9}$')]],
      land_line_number: ['', [Validators.required, Validators.pattern('[0-9]{7,9}$')]],
      address_name: ['', [Validators.required]],
      area: ['', [Validators.required]],
      building: ['', [Validators.required]],
      apartment: ['', [Validators.required]],
      country: ['', [Validators.required]],
      city: ['', [Validators.required]],
      latitude: ['', [Validators.required, Validators.pattern('^-?[0-9]{1,3}\.[0-9]{5,15}$')]],
      longitude: ['', [Validators.required, Validators.pattern('^-?[0-9]{1,3}\.[0-9]{5,15}$')]],
      image: [''],
      emirates_id: ['', [Validators.required]],
      passport: [''],
      tenant_contract: [''],
      trade_license: ['', [Validators.required]],
    });
    

    this.subscriptionService.getUserServicesHome().subscribe(
      serviceDetails => {
        this.serviceDetails = serviceDetails;

        this.selectValue = this.serviceDetails.map(serv => serv.name);
                   
        console.log(this.serviceDetails);
        
      },
        error => {
          console.log(error);
          // Handle the error
        }
      );

    // this.selectValue = ['Alaska', 'Hawaii', 'California', 'Nevada', 'Oregon', 'Washington', 'Arizona', 'Colorado', 'Idaho', 'Montana', 'Nebraska', 'New Mexico', 'North Dakota', 'Utah', 'Wyoming', 'Alabama', 'Arkansas', 'Illinois', 'Iowa'];

    
    this.submitPressed = false;
    this.validation = false;
    this.submitPressedFreelancer = false;
    this.validation_freelancer = false;
    this.submitPressedCompany = false;
    this.validation_company = false;

    this.breadCrumbItems = [{ label: 'Maps' }, { label: 'Google Maps', active: true }];
    this._initPanorama();
    this.markerVisible = false;
  }

  _initPanorama() {
    if (isPlatformBrowser(this.platformId)) {
        this.mapsAPILoader.load().then(() => {
            const center = { lat: this.latitude, lng: this.longitude };
            const map = new window['google'].maps.Map(this.streetviewMap.nativeElement, {
                center, 
                zoom: 12, 
                scrollwheel: true
            });

        });

    }
}

mapLeftClick(event) {
  this.latitude = event.coords.lat;
  this.longitude = event.coords.lng;
  this.validationform.get('latitude').setValue(this.latitude);
  this.validationform.get('longitude').setValue(this.longitude);
  this.validationfreelancer.get('latitude').setValue(this.latitude);
  this.validationfreelancer.get('longitude').setValue(this.longitude);
  this.validationcompany.get('latitude').setValue(this.latitude);
  this.validationcompany.get('longitude').setValue(this.longitude);

  this.markerVisible = true;  // Show the marker on left-click
}


  private async _fetchData() {
    const apiKey = 'AIzaSyBzCU795ZIE7glpEbOU18uos6sRGtKT7E0';
    const apiUrl = `https://api.example.com/location?key=${apiKey}`;
    const response = await fetch(apiUrl);
    const data = await response.json();

    this.markers = [
      { latitude: data.latitude, longitude: data.longitude }
    ];
    this.latitude = data.latitude;
    this.longitude = data.longitude;
  }

  changeActiveTab(tab: number) {
    console.log('Changing tab to:', tab);
    this.activeTab = tab;
  }



  onTabChange(event) {
    this.validationform.reset();
    this.validationfreelancer.reset();
    this.validationcompany.reset();

    this.isImageValid = true;
    this.isImageValidFreelancer = true;
    this.isEmirateIDValidFreelancer = true;
    this.isPassportValidFreelancer = true;
    this.isTenantContractValidFreelancer = true;
    this.isImageValidCompany = true;
    this.isEmirateIDValidCompany = true;
    this.isPassportValidCompany = true;
    this.isTenantContractValidCompany = true;
    this.isTradeLicenseValidCompany = true;
    
    this.formData.image = null;
    this.formData.image_freelancer = null;
    this.formData.emirates_id_freelancer = null;
    this.formData.passport_freelancer = null;
    this.formData.tenant_contract_freelancer = null;
    this.formData.image_company = null;
    this.formData.emirates_id_company = null;
    this.formData.passport_company = null;
    this.formData.tenant_contract_company = null;
    this.formData.trade_license_company = null;
    
    this.submitPressed = false;
    this.validation = false;
    this.submitPressedFreelancer = false;
    this.validation_freelancer = false;
    this.submitPressedCompany = false;
    this.validation_company = false;


    
    if (event.nextId == '1') {
      console.log("1");
      
    } else if (event.nextId == '2') {
      console.log("2");
      // this.changeTab(2);
    } else if (event.nextId == '3') {
      console.log("3");
      // this.changeTab(3);
    } else {
      console.log("Testing-----");
    }
  }


  goToNextStep() {
    this.submitPressed = false; 
    this.submitPressedFreelancer = false;
    this.submitPressedCompany = false;
  }
  

  goToPreviousStep() {
    this.submitPressed = false; 
    this.submitPressedFreelancer = false;
    this.submitPressedCompany = false;
  }

  validateFile(event: Event, allowedFileTypes: string[], maxFileSize: number): {isValid: boolean, file?: File, error?: any} {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) {
      return { isValid: false, error: { 'required': true } };
    }
    if (!allowedFileTypes.includes(file.type)) {
      return { isValid: false, error: { 'invalidFileType': true }};
    }
    if (file.size > maxFileSize) {
      return { isValid: false, error: { 'maxSizeExceeded': true }};
    }
    return { isValid: true, file };
  }


  // -------------------------- Customer -------------------------
  submitData() {
    this.submitPressed = true;
    this.validation = true;
    const imageInput = document.getElementById('validationCustom12');
    const event = new Event('change');
    imageInput.dispatchEvent(event);

  }

  get form() {
    return this.validationform.controls;
  }  

  getCurrentLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.markerVisible = true;
        console.log('Latitude: ' + this.latitude);
        console.log('Longitude: ' + this.longitude);
        this.validationform.get('latitude').setValue(this.latitude);
        this.validationform.get('longitude').setValue(this.longitude);
        
        }, (error) => {
          console.log(error);
        });
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    
  }


  validateImage(event) {
  
    if(!event.target.files[0]) {
      // No file selected
      this.isImageValid = true;
      return;
    }

    const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    const maxFileSize = 5 * 1024 * 1024; // 5 MB
    const {isValid, file, error} = this.validateFile(event, allowedFileTypes, maxFileSize);
    console.log(isValid, file, error);
    if (isValid) {
      this.formData.image = file;
      this.validationform.controls['image'].setErrors(null);
      this.isImageValid = true;
      
    } else {
        console.log(error);
        this.validationform.controls['image'].setErrors(error);
        console.log(error);
        this.isImageValid = false;
    }
  }

  validSubmit() {
    if (this.wizard.currentStepIndex === 2 && this.submitPressed){
      Object.keys(this.validationform.controls).forEach(key => {
        const controlErrors = this.validationform.get(key).errors;
        if (controlErrors) {
          console.log('Errors in', key, controlErrors);
          Swal.fire('Errors!', 'Errors in Field : ' + key , 'error');
        }
      });
    }

    if (this.wizard.currentStepIndex === 2 && this.submitPressed && this.validationform.valid) {
      const formValues = this.validationform.value;

      // Create a new FormData object
      const formDataCustomer = new FormData();

      // Add the form data fields to the FormData object
      formDataCustomer.append('services_selected', "");
      formDataCustomer.append('email', formValues.email);
      formDataCustomer.append('name', formValues.name);
      formDataCustomer.append('password', formValues.password);
      formDataCustomer.append('gender', formValues.gender);
      formDataCustomer.append('phone_number', '+971' + formValues.phone_number);
      formDataCustomer.append('group_choice', 'customers');
      formDataCustomer.append('land_line_number', "");
      formDataCustomer.append('address.address_name', formValues.address_name);
      formDataCustomer.append('address.area', formValues.area);
      formDataCustomer.append('address.building', formValues.building);
      formDataCustomer.append('address.apartment', formValues.apartment);
      formDataCustomer.append('address.country', formValues.country);
      formDataCustomer.append('address.city', formValues.city);
      formDataCustomer.append('address.latitude', formValues.latitude);
      formDataCustomer.append('address.longitude', formValues.longitude);
      formDataCustomer.append('address.created_by.email', formValues.email);
      formDataCustomer.append('profile.user.email', formValues.email);

      if (this.formData.image) {
        formDataCustomer.append('profile.image', this.formData.image, formValues.image.name);
      }

      this.authenticationService.register(formDataCustomer);

    } else {
      this.submitPressed = false;
    }
  }


  // -------------------------- Freelancer -------------------------
  submitDataFreelancer() {
    this.submitPressedFreelancer = true;
    this.validation_freelancer = true;
    const imageInput = document.getElementById('validationCustom12f');
    const emirateIDInput = document.getElementById('validationCustom13f');
    const passportInput = document.getElementById('validationCustom14f');
    const bankInput = document.getElementById('validationCustom15f');

    const event = new Event('change');
    imageInput.dispatchEvent(event);
    emirateIDInput.dispatchEvent(event);
    passportInput.dispatchEvent(event);
    // bankInput.dispatchEvent(event);
  }

  get formFreelancer() {
    return this.validationfreelancer.controls;
  }  

  getCurrentLocationFreelancer(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.markerVisible = true;
        console.log('Latitude: ' + this.latitude);
        console.log('Longitude: ' + this.longitude);
        this.validationfreelancer.get('latitude').setValue(this.latitude);
        this.validationfreelancer.get('longitude').setValue(this.longitude);
        }, (error) => {
          console.log(error);
        });
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    
  }

  validateImageFreelancer(event) {
    if(!event.target.files[0]) {
      // No file selected
      this.isImageValidFreelancer = true;
      return;
    }

    const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    const maxFileSize = 5 * 1024 * 1024; // 5 MB
    const {isValid, file, error} = this.validateFile(event, allowedFileTypes, maxFileSize);
    console.log(isValid, file, error);
    if (isValid) {
      this.formData.image_freelancer = file;
      this.validationfreelancer.controls['image'].setErrors(null);
      this.isImageValidFreelancer = true;
      
    } else {
        console.log(error);
        this.validationfreelancer.controls['image'].setErrors(error);
        console.log(error);
        this.isImageValidFreelancer = false;
    }
  
  }

  validaEmirateIDFreelancer(event) {

    const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    const maxFileSize = 5 * 1024 * 1024; // 5 MB
    const {isValid, file, error} = this.validateFile(event, allowedFileTypes, maxFileSize);
    console.log(isValid, file, error);
    if (isValid) {
      this.formData.emirates_id_freelancer = file;
      this.validationfreelancer.controls['emirates_id'].setErrors(null);
      this.isEmirateIDValidFreelancer = true;
      
    } else {
        console.log(error);
        this.validationfreelancer.controls['emirates_id'].setErrors(error);
        this.isEmirateIDValidFreelancer = false;
    }
  

  }

  validaPassportFreelancer(event) {

    if(!event.target.files[0]) {
      // No file selected
      this.isPassportValidFreelancer = true;
      return;
    }


    const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    const maxFileSize = 5 * 1024 * 1024; // 5 MB
    const {isValid, file, error} = this.validateFile(event, allowedFileTypes, maxFileSize);
    console.log(isValid, file, error);
    if (isValid) {
      this.formData.passport_freelancer = file;
      this.validationfreelancer.controls['passport'].setErrors(null);
      this.isPassportValidFreelancer = true;
      
    } else {
        console.log(error);
        this.validationfreelancer.controls['passport'].setErrors(error);
        this.isPassportValidFreelancer = false;
    }

  }

  // validaBankStatementFreelancer(event) {

  //   const allowedFileTypes = ['application/pdf'];
  //   const maxFileSize = 5 * 1024 * 1024; // 5 MB
  //   const {isValid, file, error} = this.validateFile(event, allowedFileTypes, maxFileSize);
  //   console.log(isValid, file, error);
  //   if (isValid) {
  //     this.formData.bank_statement_freelancer = file;
  //     this.validationfreelancer.controls['bank_statement'].setErrors(null);
  //     this.isBankStatementValidFreelancer = true;
      
  //   } else {
  //       console.log(error);
  //       this.validationfreelancer.controls['bank_statement'].setErrors(error);
  //       this.isBankStatementValidFreelancer = false;
  //   }

  // }
  
    

  validSubmitFreelancer() {

    if (this.wizard.currentStepIndex === 2 && this.submitPressedFreelancer){
      Object.keys(this.validationfreelancer.controls).forEach(key => {
        const controlErrors = this.validationfreelancer.get(key).errors;
        if (controlErrors) {
          console.log('Errors in', key, controlErrors);
          Swal.fire('Errors!', 'Errors in Field : ' + key , 'error');
        }
      });
    }
    
    
    if (this.wizard.currentStepIndex === 2 && this.submitPressedFreelancer && this.validationfreelancer.valid) {
      const formValues = this.validationfreelancer.value;

      // Create a new FormData object
      const formDataFreeLancer = new FormData();
      if(formValues.services.length < 5){
        console.log(formValues.services.join(';'));
        // Add the form data fields to the FormData object
        formDataFreeLancer.append('services_selected', formValues.services.join(';'));
        formDataFreeLancer.append('email', formValues.email);
        formDataFreeLancer.append('name', formValues.name);
        formDataFreeLancer.append('password', formValues.password);
        formDataFreeLancer.append('gender', formValues.gender);
        formDataFreeLancer.append('phone_number', '+971' + formValues.phone_number);
        formDataFreeLancer.append('land_line_number', '');
        formDataFreeLancer.append('group_choice', 'vendors');
        formDataFreeLancer.append('address.address_name', formValues.address_name);
        formDataFreeLancer.append('address.area', formValues.area);
        formDataFreeLancer.append('address.building', formValues.building);
        formDataFreeLancer.append('address.apartment', formValues.apartment);
        formDataFreeLancer.append('address.country', formValues.country);
        formDataFreeLancer.append('address.city', formValues.city);
        formDataFreeLancer.append('address.latitude', formValues.latitude);
        formDataFreeLancer.append('address.longitude', formValues.longitude);
        formDataFreeLancer.append('address.created_by.email', formValues.email);
        formDataFreeLancer.append('profile.user.email', formValues.email);

        if (this.formData.image_freelancer) {
          formDataFreeLancer.append('profile.image', this.formData.image_freelancer, formValues.image.name);
        }
        formDataFreeLancer.append('profile.user_type', 'freelancer');
        formDataFreeLancer.append('profile.emirates_id', this.formData.emirates_id_freelancer, formValues.emirates_id.name);
        if (this.formData.passport_freelancer) {
          formDataFreeLancer.append('profile.passport', this.formData.passport_freelancer, formValues.passport.name);
        }
          // formDataFreeLancer.append('profile.bank_statement', this.formData.bank_statement_freelancer, formValues.bank_statement.name);


        // console.log(formDataFreeLancer);
        this.authenticationService.register(formDataFreeLancer);
      } else {
        Swal.fire('Errors!', 'Maximum 4 Service You can select.' , 'error');
      }
    }
  }


// -------------------------- Company -------------------------
submitDataCompany() {
  this.submitPressedCompany = true;
  this.validation_company = true;

  const imageInput = document.getElementById('validationCustom12c');
    const emirateIDInput = document.getElementById('validationCustom13c');
    const passportInput = document.getElementById('validationCustom14c');
    const bankInput = document.getElementById('validationCustom15c');
    const tradeInput = document.getElementById('validationCustom16c');

    const event = new Event('change');
    imageInput.dispatchEvent(event);
    emirateIDInput.dispatchEvent(event);
    passportInput.dispatchEvent(event);
    bankInput.dispatchEvent(event);
    tradeInput.dispatchEvent(event);
}

get formCompany() {
  return this.validationcompany.controls;
}  

getCurrentLocationCompany(): void {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(position => {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      this.markerVisible = true;
      console.log('Latitude: ' + this.latitude);
      console.log('Longitude: ' + this.longitude);
      this.validationcompany.get('latitude').setValue(this.latitude);
      this.validationcompany.get('longitude').setValue(this.longitude);
      }, (error) => {
        console.log(error);
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  
}

validateImageCompany(event) {
  if(!event.target.files[0]) {
    // No file selected
    this.isImageValidCompany = true;
    return;
  }

  const allowedFileTypes = ['image/jpeg', 'image/png', 'image/gif'];
  const maxFileSize = 5 * 1024 * 1024; // 5 MB
  const {isValid, file, error} = this.validateFile(event, allowedFileTypes, maxFileSize);
  console.log(isValid, file, error);
  if (isValid) {
    this.formData.image_company = file;
    this.validationcompany.controls['image'].setErrors(null);
    this.isImageValidCompany = true;
    
  } else {
      console.log(error);
      this.validationcompany.controls['image'].setErrors(error);
      console.log(error);
      this.isImageValidCompany = false;
  }

}

validaEmirateIDCompany(event) {

  const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
  const maxFileSize = 5 * 1024 * 1024; // 5 MB
  const {isValid, file, error} = this.validateFile(event, allowedFileTypes, maxFileSize);
  console.log(isValid, file, error);
  if (isValid) {
    this.formData.emirates_id_company = file;
    this.validationcompany.controls['emirates_id'].setErrors(null);
    this.isEmirateIDValidCompany = true;
    
  } else {
      console.log(error);
      this.validationcompany.controls['emirates_id'].setErrors(error);
      this.isEmirateIDValidCompany = false;
  }


}

validaPassportCompany(event) {

  if(!event.target.files[0]) {
    // No file selected
    this.isPassportValidCompany = true;
    return;
  }

  const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
  const maxFileSize = 5 * 1024 * 1024; // 5 MB
  const {isValid, file, error} = this.validateFile(event, allowedFileTypes, maxFileSize);
  console.log(isValid, file, error);
  if (isValid) {
    this.formData.passport_company = file;
    this.validationcompany.controls['passport'].setErrors(null);
    this.isPassportValidCompany = true;
    
  } else {
      console.log(error);
      this.validationcompany.controls['passport'].setErrors(error);
      this.isPassportValidCompany = false;
  }

}

validaTenantContractCompany(event) {
  
  if(!event.target.files[0]) {
    // No file selected
    this.isTenantContractValidCompany = true;
    return;
  }

  const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
  const maxFileSize = 5 * 1024 * 1024; // 5 MB
  const {isValid, file, error} = this.validateFile(event, allowedFileTypes, maxFileSize);
  console.log(isValid, file, error);
  if (isValid) {
    this.formData.tenant_contract_company = file;
    this.validationcompany.controls['tenant_contract'].setErrors(null);
    this.isTenantContractValidCompany = true;
    
  } else {
      console.log(error);
      this.validationcompany.controls['tenant_contract'].setErrors(error);
      this.isTenantContractValidCompany = false;
  }

}

validTradeLicenseCompany(event) {

  const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
  const maxFileSize = 5 * 1024 * 1024; // 5 MB
  const {isValid, file, error} = this.validateFile(event, allowedFileTypes, maxFileSize);
  console.log(isValid, file, error);
  if (isValid) {
    this.formData.trade_license_company = file;
    this.validationcompany.controls['trade_license'].setErrors(null);
    this.isTradeLicenseValidCompany = true;
    
  } else {
      console.log(error);
      this.validationcompany.controls['trade_license'].setErrors(error);
      this.isTradeLicenseValidCompany = false;
  }

}

  

validSubmitCompany() {
  console.log(this.wizard.currentStepIndex);

  if (this.wizard.currentStepIndex === 2 && this.submitPressedCompany){
    Object.keys(this.validationcompany.controls).forEach(key => {
      const controlErrors = this.validationcompany.get(key).errors;
      if (controlErrors) {
        console.log('Errors in', key, controlErrors);
        Swal.fire('Errors!', 'Errors in Field : ' + key , 'error');
      }
    });
  }

  if (this.wizard.currentStepIndex === 2 && this.submitPressedCompany && this.validationcompany.valid) {
    const formValues = this.validationcompany.value;

    // Create a new FormData object
    const formDataCompany = new FormData();
    if(formValues.services.length < 5){
      // Add the form data fields to the FormData object
      formDataCompany.append('services_selected', formValues.services.join(';'));
      formDataCompany.append('email', formValues.email);
      formDataCompany.append('name', formValues.name);
      formDataCompany.append('password', formValues.password);
      formDataCompany.append('gender', "M");
      formDataCompany.append('phone_number', '+971' + formValues.phone_number);
      formDataCompany.append('land_line_number', '+971' + formValues.land_line_number);
      formDataCompany.append('group_choice', 'vendors');
      formDataCompany.append('address.address_name', formValues.address_name);
      formDataCompany.append('address.area', formValues.area);
      formDataCompany.append('address.building', formValues.building);
      formDataCompany.append('address.apartment', formValues.apartment);
      formDataCompany.append('address.country', formValues.country);
      formDataCompany.append('address.city', formValues.city);
      formDataCompany.append('address.latitude', formValues.latitude);
      formDataCompany.append('address.longitude', formValues.longitude);
      formDataCompany.append('address.created_by.email', formValues.email);
      formDataCompany.append('profile.user.email', formValues.email);
      if (this.formData.image_company) {
        formDataCompany.append('profile.image', this.formData.image_company, formValues.image.name);
      }
      formDataCompany.append('profile.user_type', 'company_vendor');
      formDataCompany.append('profile.emirates_id', this.formData.emirates_id_company, formValues.emirates_id.name);
      if (this.formData.passport_company) {
        formDataCompany.append('profile.passport', this.formData.passport_company, formValues.passport.name);
      }
      if (this.formData.tenant_contract_company) {
        formDataCompany.append('profile.tenant_contract', this.formData.tenant_contract_company, formValues.tenant_contract.name);
      }
      formDataCompany.append('profile.trade_license', this.formData.trade_license_company, formValues.trade_license.name);


      console.log(formDataCompany);
      this.authenticationService.register(formDataCompany);
    }  else {
      Swal.fire('Errors!', 'Maximum 4 Service You can select.' , 'error');
    }

  }
}




}